import gql from 'graphql-tag';

export const UPDATE_NOTIFICATION = gql`
  mutation updateNotification($updateNotificationInput: UpdateNotificationInput!, $id: ID!) {
    updateNotification(updateNotificationInput: $updateNotificationInput, id: $id) {
      id
      type
      read
      ride {
        id
        driver {
          id
          firstName
          lastName
          gender
          userImg
          userVehicles {
            make {
              name
            }
            model
            spec {
              engineSize
              fuelConsumption
            }
          }
        }
        seats
        startDate
        pricePerSeat
        startPoint {
          name
          location {
            lat
            lng
          }
          eta
        }
        endPoint {
          name
          location {
            lat
            lng
          }
          eta
        }
        waypoints {
          id
          name
        }
        waypointsEta {
          waypointId
          eta
        }
        createdAt
      }
      notificationReceiver {
        id
      }
      message
      createdAt
    }
  }
`;
